import dayjs from "dayjs";
import type { ShipmentNote } from "../../hooks/react-query/linehaul/useLoadBoardNotes";

export const mockShipmentNotes: Record<string, ShipmentNote[] | undefined> = {
  "133001229": [
    {
      id: 1,
      shipmentId: 133001229,
      content: "Shipment requires special handling",
      createdBy: "Test User",
      createdOn: dayjs("2024-12-02T10:00:00").toDate(),
      modifiedBy: "Test User",
      modifiedOn: dayjs("2024-12-02T10:00:00").toDate(),
      isEdited: false,
      creatorId: "7fd75d50-622e-4258-9027-606eb0f11809",
    },
    {
      id: 2,
      shipmentId: 133001229,
      content: "Customer confirmed delivery window",
      createdBy: "Another User",
      createdOn: dayjs("2024-12-02T11:30:00").toDate(),
      modifiedBy: "Another User",
      modifiedOn: dayjs("2024-12-02T11:30:00").toDate(),
      isEdited: false,
      creatorId: "abc123-different-user-id",
    },
  ],
};
